import './how-to-create-steps.scss';
import { useTranslation } from '@translations';

export const HowToCreateSteps = () => {
    const { howToCreateInfo } = useTranslation();
    const { item1, item2, item3, item4, item5 } = howToCreateInfo;

    return (
        <ol className="number-list">
            <li>{item1}</li>
            <li>{item2}</li>
            <li>{item3}</li>
            <li className="number-list--blue">{item4}</li>
            <li>{item5}</li>
        </ol>
    );
};
